module.exports = {
  // BASE_URL: 'https://api1.taichinhpvf.com/api/v1',
  // SOCKET_SERVER_URL: 'https://api1.taichinhpvf.com',
  BASE_URL: 'https://api.kebhanabank.org/api/v1',
  SOCKET_SERVER_URL: 'https://api.kebhanabank.org',
  // BASE_URL: 'http://localhost/api/v1',
  // SOCKET_SERVER_URL: 'http://127.0.0.1'
};
